import { render, staticRenderFns } from "./cuadernos.vue?vue&type=template&id=1b0a06d2&scoped=true"
import script from "./cuadernos.vue?vue&type=script&lang=js"
export * from "./cuadernos.vue?vue&type=script&lang=js"
import style0 from "./cuadernos.vue?vue&type=style&index=0&id=1b0a06d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0a06d2",
  null
  
)

export default component.exports